<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="680px"
    @close="close"
    :close-on-click-modal="false"
  >
    <el-form ref="form" label-width="120px" :model="form" :rules="rules">
      <el-form-item label="公寓名" prop="title">
        <el-input v-model="form.title" placeholder="请输入公寓名" />
      </el-form-item>
      <el-form-item label="公寓地址" prop="address">
        <el-input v-model="form.address" class="input-width" />
      </el-form-item>
      <el-form-item label="所在州" prop="provinceId">
        <el-select v-model="form.provinceId" placeholder="请选择">
          <el-option
            v-for="item in provinces"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在街区" prop="cityId" v-if="form.provinceId">
        <el-select v-model="form.cityId" placeholder="请选择">
          <el-option
            v-for="item in fomatCitys()"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="附近地标" prop="landmark">
        <el-input v-model="form.landmark" placeholder="请输入附近地标" />
      </el-form-item>
      <el-form-item label="距离地标距离" prop="distance">
        <el-input v-model="form.distance" placeholder="请输入距离地标距离" />
      </el-form-item>
      <el-form-item label="步行" prop="walkTime">
        <el-input v-model="form.takeTimeList[0]" placeholder="请输入步行时间" />
      </el-form-item>
      <el-form-item label="公交" prop="transitTime">
        <el-input v-model="form.takeTimeList[1]" placeholder="请输入公交时间" />
      </el-form-item>
      <el-form-item label="打车" prop="taxiTime">
        <el-input v-model="form.takeTimeList[2]" placeholder="请输入打车时间" />
      </el-form-item>
      <el-form-item label="价格" prop="price">
        <el-input
          :style="{ width: '200px' }"
          v-model.number="form.price"
          placeholder="请输入价格"
        ></el-input>
        /
        <el-select v-model="form.period" placeholder="请选择">
          <el-option
            v-for="item in periods"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签" prop="tag">
        <el-select
          v-model="form.tag"
          multiple
          allow-create
          filterable
          default-first-option
          placeholder="请选择或填写标签"
          style="width: 100%"
        >
          <el-option
            v-for="item in apartmentTags"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公寓概况" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          placeholder="请输入公寓概况"
        />
      </el-form-item>
      <el-form-item label="公寓设施" prop="facility">
        <el-select
          v-model="form.facility"
          multiple
          filterable
          default-first-option
          placeholder="请选择或填写公寓设施"
          style="width: 100%"
        >
          <el-option
            v-for="item in facilityList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="vrUrl" prop="vrUrl">
        <el-input v-model="form.vrUrl" placeholder="请输入vrUrl" />
      </el-form-item>
      <el-form-item label="优惠信息" prop="promoteInfo">
        <el-input
          v-model="form.promoteInfo"
          type="textarea"
          placeholder="请输入优惠信息"
        />
      </el-form-item>
      <el-form-item label="退订政策" prop="refundInfo">
        <el-input
          v-model.number="form.refundInfo"
          type="textarea"
          placeholder="请输入退订政策"
        />
      </el-form-item>
      <el-form-item label="预定须知" prop="reserveInfo">
        <el-input
          v-model="form.reserveInfo"
          type="textarea"
          placeholder="请输入预定须知"
        />
      </el-form-item>
      
      <el-form-item
        style="alignitems: center;"
        v-for="(item, index) in form.customIconList"
        :key="item"
        prop="facilityImage"
      >
        <div style="display: flex; alignItems: center;justifyContent: space-between">
         <el-input
         style="width: 200px;height: 32px"
          v-model="item.name"
          placeholder="请输入设施名称"
        />
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="
              (file, res, fileList) => custom_icon_success(file, res, fileList, index)
            "
          >
            <img
              v-if="form.customIconList[index].url"
              :src="form.customIconList[index].url"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <i class="el-icon-delete delCustomIcon" @click="delCustomIcon(index)"></i>
        </div>
      </el-form-item>
      <el-button  type="primary" icon="el-icon-plus" @click="addCustomIcon" class="addCustomIcon">添加设施</el-button>
      <el-form-item
        style="alignitems: center;"
        v-for="(item, index) in iconListDefaults"
        :key="item"
        :label="item.name"
        prop="facilityImage"
      >
        <div style="display: flex; alignItems: center">
          <img style="height: 70px" :src="item.url" alt="" />
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="
              (file, res, fileList) => icon_success(file, res, fileList, index)
            "
            :on-remove="
              (file, res, fileList) => icon_remove(file, res, fileList, index)
            "
          >
            <img
              v-if="form.iconList[index]"
              :src="form.iconList[index].url"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-form-item>
      <!-- <el-form-item label="常见问题" prop="question">
        <el-input v-model.number="form.question" placeholder="请输入常见问题" />
      </el-form-item> -->
      <el-form-item
        :label="index == 0 ? '常见问题' : ''"
        v-for="(item, index) of form.question"
        :key="index"
      >
        <el-col :span="10">
          <el-form-item :ref="index + 'q'" :prop="'question.' + index + '.q'">
            <el-input v-model="item.q" placeholder="请输入问题"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" style="margin-left: 20px">
          <el-form-item :ref="index + 'a'" :prop="'question.' + index + '.a'">
            <el-input v-model="item.a" placeholder="请输入答案"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="addQuestion"
            v-if="index == 0"
          >
            添加
          </el-button>
          <el-button
            style="margin-left: 20px"
            type="primary"
            v-if="index !== 0"
            @click="delQuestion(index)"
          >
            删除
          </el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
      <el-form-item label="公寓图片" prop="image">
        <ul class="el-upload-list el-upload-list--picture-card apartmentImgs">
          <draggable v-model="form.image"  tag="transition-group"  handle=".animated ">
            <transition-group>
            <li
              v-for="(item, index) in form.image"
              :key="item"
              class="el-upload-list__item is-success animated"
            >
              <img
                :src="item.url"
                alt=""
                class="el-upload-list__item-thumbnail"
              />
              <!-- <i class="el-icon-close"></i> -->
              <!-- <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemoveFileDetail(index)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span> -->
            </li>
            </transition-group>
          </draggable>
        </ul>
        <el-upload
          class="apartmentImg"
          ref="upload"
          :multiple="true"
          :auto-upload="false"
          :show-file-list="true"
          :action="QNUploadURL"
          :data="uploadToken"
          list-type="picture-card"
          :file-list="form.image"
          :http-request="uploadFile"
          :on-remove="image_remove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-button size="small" type="primary" @click="submitUpload">点击上传</el-button>
        建议尺寸比例 690:320
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import  {VueDraggableNext }  from 'vue-draggable-next'

  import axios from 'axios'
  import {
    updateBuilding,
    createBuilding,
    getProvinceAll,
    getCityAll,
  } from '@/api/apartment'
  import { getUploadToken } from '@/api/app'
  import { QNUploadURL, QNHost } from '@/config/net.config'
  import { apartmentTags, facilityList } from '@/utils/const'
  export default {
    name: 'BuildingEdit',
    emits: ['fetch-data'],
     components: {
            draggable:VueDraggableNext
        },
    data() {
      return {
        title: '',
        showEditImage:true,
        uploadToken: {},
        QNUploadURL,
        apartmentTags,
        facilityList,
        form: {
          apartmentId: '',
          title: '',
          address: '',
          provinceId: '',
          cityId: '',
          landmark: '',
          distance: '',
          price: '',
          period: '',
          tag: [],
          image: [],
          description: '',
          promoteInfo: '',
          refundInfo: '',
          reserveInfo: '',
          vrUrl:'',
          facility: [],
          takeTimeList: [],
          iconList: [],
          customIconList: [],
          question: [
            {
              q: '',
              a: '',
            },
          ],
          order: 1,
        },
        iconListDefaults: [
          {
            name: '电视',
            url: 'https://qbox.yeahotel.com/Fi1QLukYrhA1-Xrgtz1KM4OoJQjk',
          },
          {
            name: '冰箱',
            url: 'https://qbox.yeahotel.com/Fn_rDR7iryMNiAqOcgTzo8ZhFErr',
          },
          {
            name: '微波炉',
            url: 'https://qbox.yeahotel.com/FpW8y05fkGv3EpxQAyDLkI6zxoRB',
          },
          {
            name: '空调',
            url: 'https://qbox.yeahotel.com/FiH7kX5f-LA6QhaT4Ut6grZM9SIF',
          },
          {
            name: '电饭煲',
            url: 'https://qbox.yeahotel.com/FmMQm2jgkMl7rHiX2ZfAXnCaUBFJ',
          },
          {
            name: '独卫',
            url: 'https://qbox.yeahotel.com/Fp6QKgS3m66qGrgk5wj_Nsj4wmBr',
          },
          {
            name: '淋浴',
            url: 'https://qbox.yeahotel.com/FjgSbosa8zKTHPfmE7xWYPol7MnY',
          },
          {
            name: '浴缸',
            url: 'https://qbox.yeahotel.com/FtwRmAnQvMxBc-cQmn7widSU-ZL9',
          },
        ],
        rules: {
          title: [
            { required: true, trigger: 'blur', message: '请输入公寓名称' },
          ],
          provinceId: [
            { required: true, trigger: 'blur', message: '请选择所在州' },
          ],
          cityId: [
            { required: true, trigger: 'blur', message: '请选择所在街区' },
          ],
          landmark: [
            { required: true, trigger: 'blur', message: '请输入附近地标' },
          ],
          distance: [
            { required: true, trigger: 'blur', message: '请输入距离地标距离' },
          ],
          price: [{ required: true, trigger: 'blur', message: '请输入价格' }],
          tag: [{ required: true, trigger: 'blur', message: '请输入标签' }],
          description: [
            { required: true, trigger: 'blur', message: '请输入公寓概况' },
          ],
        },
        dialogFormVisible: false,
        periods: [
          { value: 0, label: '月' },
          { value: 1, label: '周' },
        ],
        formDate: '',
      }
    },
    methods: {
      // 设置问题
      addQuestion() {
        this.form.question.push({
          q: '',
          a: '',
        })
      },
      delQuestion(index) {
        this.form.question.splice(index, 1)
      },
      fomatCitys() {
        const citys = this.citys
          .filter((i) => i.provinceId === this.form.provinceId)
          .map((i) => ({
            label: i.title,
            value: i.cityId,
          }))
        return citys
      },
      async showEdit(row) {
        const province = await getProvinceAll({})
        const city = await getCityAll({})
        this.provinces = province.map((i) => ({
          label: i.title,
          value: i.provinceId,
        }))
        this.citys = city
        if (row.apartmentId) {
          this.title = '编辑公寓'
          this.form = Object.assign(this.form, {
            ...row.basic,
            title: row.title,
            apartmentId: row.apartmentId,
          })
        } else {
          this.title = '新增公寓'
        }
        this.dialogFormVisible = true
        const token = await getUploadToken({})

        this.uploadToken = { token: token.token }
      },
      addCustomIcon(){
        this.form.customIconList.push({
          name:''
        })
      },
      delCustomIcon(index){
        this.form.customIconList.splice(index,1)
      },
      custom_icon_success(file, res, fileList, index){
if (!file.hash) {
          this.$message.error('图片上传失败')
          return
        }
        this.form.customIconList[index] = {
          name: this.form.customIconList[index].name,
          url: QNHost + '/' + file.hash,
        }
      },
      image_remove(file, fileList) {
        this.form.image = fileList.map((e) => ({
          name: e.name,
          url: e.url,
        }))
      },
      handleRemoveFileDetail(index) {
        this.form.image.splice(index, 1)
      },
      async uploadFile(file) {
        console.log(file)
        this.formData.set('file', file.file)
        const { data: res } = await axios.post(
          this.QNUploadURL,
          this.formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        )
        if (res.hash) {
          this.$message.success('发布成功！')
          this.form.image.push({
            name: file.file.name,
            url: QNHost + '/' + res.hash,
          })
          console.log(this.form.image, ' this.form.image')
        } else {
          return this.$message.error('发布失败！')
        }
      },
      // 点击按钮触发
      async submitUpload() {
        this.formData = new FormData()
        // this.formData.append("content", this.blogData.content);
        this.formData.append('token', this.uploadToken.token)
        this.$refs.upload.submit()
        this.showEditImage=false
      },
      icon_remove(file, res, fileList, index) {
        this.form.iconList.police(index,1)
      },
      icon_success(file, res, fileList, index) {
        if (!file.hash) {
          this.$message.error('图片上传失败')
          return
        }
        this.form.iconList[index] = {
          name: this.iconListDefaults[index].name,
          url: QNHost + '/' + file.hash,
        }
      },
      async close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      async save() {
        this.$refs['form'].validate(async (valid) => {
          const apartmentId = this.form.apartmentId
          if (valid) {
            this.$baseConfirm(
              `你确定${apartmentId ? '修改' : '新增'}该公寓吗`,
              null,
              this.submitUpload(),
              async () => {
                const data = Object.assign({}, this.form)
                apartmentId
                  ? await updateBuilding(data)
                  : await createBuilding(data)

                this.$baseMessage(
                  `${apartmentId ? '修改' : '新增'}公寓成功`,
                  'success',
                  false,
                  'vab-hey-message-success'
                )
                this.$emit('fetch-data')
                this.close()
              }
            )
          } else {
            return false
          }
        })
      },
    },
  }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
 .avatar-uploader .el-upload--text{
  width: 100px;
  height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .apartmentImgs .el-upload-list__item {
    width: 60px;
    height: 60px;
  }
  .apartmentImg .el-upload-list__item-thumbnail {
    width: 50px;
  }
  .apartmentImg .el-upload-list__item {
    width: 313px;
  }
  .apartmentImg .el-upload-list__item-thumbnail {
    width: 313px;
  }
  .addCustomIcon{
    margin-left: 119px;
    margin-bottom: 20px;
  }
  .delCustomIcon{
    cursor: pointer;
  }
</style>
